module.exports = __webpack_public_path__ + "img/Weilin server equipment monitoring software.40362169.jpg";